import * as React from 'react';
import * as _ from 'lodash';
import {
    ActionBar,
    LeftActions,
    RightActions,
    HelperCalloutMessage,
    ActionBarButtonWrapper
} from './styles';
import { TCButton } from '../TCButton';
import { TC_BUTTON_TYPE } from '../TCButton/constants';
import { SIZE } from 'common/sizes';
import { ButtonWrapper } from 'common/baseComponents';

export interface ActionBarProps {
    mainActionLabel?: string
    secondaryActionLabel?: string
    thirdActionLabel?: string
    destructiveActionLabel?: string

    onMainActionClick?: () => void;
    onSecondaryActionClick?: () => void;
    onThirdActionClick?: () => void;
    onDestructiveActionClick?: () => void;

    mainActionDisabled?: boolean
    thirdActionDisabled?: boolean
    secondaryActionDisabled?: boolean
    destructiveActionDisabled?: boolean

    mainActionLoading?: boolean
    thirdActionLoading?: boolean
    secondaryActionLoading?: boolean
    destructiveActionLoading?: boolean

    mainActionHint?: string
    destructiveActionHint?: string

}


const ActionBarComponent = (props: ActionBarProps) => {
    return (
        <ActionBar>
            <LeftActions>
                {
                    props.onDestructiveActionClick &&
                    <ActionBarButtonWrapper padding={`0 ${SIZE.TWO}px`} margin={`0 0 0 ${SIZE.ONE}px`} >
                        <TCButton
                            type={TC_BUTTON_TYPE.DESTRUCTIVE}
                            disabled={props.destructiveActionDisabled}
                            onClick={props.onDestructiveActionClick}
                            loading={props.destructiveActionLoading}
                        >
                            {
                                props.destructiveActionLabel
                            }
                        </TCButton>
                    </ActionBarButtonWrapper>
                }
                {
                    props.destructiveActionHint && renderHint(props.destructiveActionHint)
                }
            </LeftActions>
            <RightActions>
                {
                    props.onThirdActionClick &&
                    <ButtonWrapper margin={`0 ${SIZE.ONE}px 0 0`}>
                        <TCButton
                            type={TC_BUTTON_TYPE.THIRDARY}
                            onClick={props.onThirdActionClick}
                            disabled={props.thirdActionDisabled ? props.thirdActionDisabled : false}
                            loading={Boolean(props.thirdActionLoading)}
                        >
                            {props.thirdActionLabel}
                        </TCButton>
                    </ButtonWrapper>
                }
                {
                    props.onSecondaryActionClick &&
                    <ButtonWrapper margin={`0 ${SIZE.ONE}px`} minWidth={`${SIZE.TWELVE}px`}>
                        <TCButton
                            type={TC_BUTTON_TYPE.SECONDARY}
                            onClick={props.onSecondaryActionClick}
                            disabled={props.secondaryActionDisabled ? props.secondaryActionDisabled : false}
                            loading={props.secondaryActionLoading}
                        >
                            {props.secondaryActionLabel}
                        </TCButton>
                    </ButtonWrapper>
                }
                {
                    <>
                        {
                            props.onMainActionClick &&
                            <ActionBarButtonWrapper margin={`0 0 0 ${SIZE.ONE}px`} minWidth={`${SIZE.TWELVE}px`} >
                                <TCButton
                                    type={TC_BUTTON_TYPE.PRIMARY}
                                    disabled={props.mainActionDisabled ? props.mainActionDisabled : false}
                                    onClick={props.onMainActionClick}
                                    loading={Boolean(props.mainActionLoading)}
                                >
                                    {props.mainActionLabel}
                                </TCButton>
                            </ActionBarButtonWrapper>
                        }
                        {
                            props.mainActionHint && renderHint(props.mainActionHint)
                        }
                    </>
                }
            </RightActions>
        </ActionBar>
    );

    function renderHint(msg) {
        return (
            <>
                {
                    <HelperCalloutMessage>
                        {
                            msg
                        }
                    </HelperCalloutMessage>
                }
            </>
        )
    }
}

export default ActionBarComponent;